<template>
  <div class="padding-xl text-lg" style="line-height: 36px" v-html="help"></div>
</template>
<script>
import config from '../../public/config/config'

export default {
  name: 'index',
  data () {
    return {
      help: config.help
    }
  }
}
</script>

<style scoped>

</style>
